import Snippet from 'src/search/Snippet'
import SnippetGrid from './SnippetGrid'

function HomepageSnippets({ snippets, SnippetComponent = Snippet }) {
  if (!snippets?.length) return null

  return (
    <SnippetGrid>
      {snippets.map(snippet => (
        <SnippetComponent
          key={snippet.objectID}
          hit={snippet}
        />
      ))}
    </SnippetGrid>
  )
}

export default HomepageSnippets
